/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentPackSuggestionAnalysisStatus =
    (typeof DocumentPackSuggestionAnalysisStatus)[keyof typeof DocumentPackSuggestionAnalysisStatus];

export const DocumentPackSuggestionAnalysisStatus = {
    Completed: 'Completed',
    Failed: 'Failed',
} as const;
